import {
  SegmentDataStructure,
  SegmentDataStructureField,
  SegmentDataStructureType,
  segmentDataStructureTypeToDataStructure,
} from "@redotech/redo-model/marketing/segments/segment-data-structures";
import {
  CustomerCharacteristicType,
  CustomerDataSource,
  SegmentConditionCategory,
} from "@redotech/redo-model/marketing/segments/segment-types";
import {
  segmentCategoryToFriendly,
  segmentCategoryToIcon,
} from "../segment-category";
import { Category } from "../trifold-selector";

export function schemaToCategories<T extends string>(
  schema: SegmentDataStructure<T> | undefined,
  availableDataSources?: CustomerDataSource[],
): Category<SegmentDataStructureField<T>>[] {
  if (!schema) {
    return [];
  }

  const fields: SegmentDataStructureField<T>[] = Object.values(schema.fields);

  // Filter fields by available data sources if provided
  const filteredFields = availableDataSources
    ? fields.filter((field) => availableDataSources.includes(field.source))
    : fields;

  return Object.values(SegmentConditionCategory).map((category) => {
    const categoryFields = filteredFields
      .filter((field) => field.category === category)
      .sort((a, b) => a.name.localeCompare(b.name));
    return {
      name: segmentCategoryToFriendly[category],
      Icon: segmentCategoryToIcon[category],
      items: categoryFields,
    };
  });
}

export function getSegmentDataStructureField<T extends string>(
  segmentType: SegmentDataStructureType,
  type: T,
): SegmentDataStructureField<T> | undefined {
  const schema = segmentDataStructureTypeToDataStructure[segmentType] as
    | SegmentDataStructure<T>
    | undefined;
  return schema?.fields[type];
}

export type Characteristic =
  SegmentDataStructureField<CustomerCharacteristicType>;
